import { useNavigate } from "react-router-dom"
import Button from "../../../components/ui/Button"
import Card, { CardBody } from "../../../components/ui/Card"
import CreateProject from "./CreateProject"

const NewProjectPage = ({ preselectedTopicId, preselectedTopic }) => {
  const navigate = useNavigate()

  const handleCancel = () => {
    navigate("/dashboard/project")
  }

  const handleSuccess = () => {
    navigate("/dashboard/project", { replace: true })
  }

  return (
    <div className="min-h-[calc(100vh-220px)]">
      <div className="flex items-center justify-between gap-3 mb-4">
        <div>
          <p className="text-sm font-semibold text-slate-900">New Project</p>
          <p className="text-sm text-slate-600">Fill the steps below to create your project.</p>
        </div>
        <Button variant="outline" onClick={handleCancel}>
          Back to Projects
        </Button>
      </div>

      <Card className="shadow-soft bg-white">
        <CardBody className="flex justify-center">
          <CreateProject
            preselectedTopicId={preselectedTopicId}
            preselectedTopic={preselectedTopic}
            onSuccess={handleSuccess}
            onCancel={handleCancel}
          />
        </CardBody>
      </Card>
    </div>
  )
}

export default NewProjectPage

